module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "sec-5"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Contents"
    }
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "pz4-1"
    }
  }, [_c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter01b#ab_01b",
      "id": "ba_01b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ebook Instructions")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz4-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/part01#ab_part01",
      "id": "ba_part01"
    }
  }, [_c('b', [_vm._v("1. Jesus Is Your")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pAFe"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02#ab_02",
      "id": "ba_02"
    }
  }, [_vm._v("Savior")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AjK"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02a#ab_02a",
      "id": "ba_02a"
    }
  }, [_vm._v("Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pA4h"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter03#ab_03",
      "id": "ba_03"
    }
  }, [_vm._v("Love")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AX"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter04#ab_04",
      "id": "ba_04"
    }
  }, [_vm._v("Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "A4r"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter05#ab_05",
      "id": "ba_05"
    }
  }, [_vm._v("Forgiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Aiu"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter06#ab_06",
      "id": "ba_06"
    }
  }, [_vm._v("Righteousness")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AJ"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter07#ab_07",
      "id": "ba_07"
    }
  }, [_vm._v("Deliverer")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "APq"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#ab_08",
      "id": "ba_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fellowship")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "A2D"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#ab_09",
      "id": "ba_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Example")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "A1q"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ab_10",
      "id": "ba_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Companion")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "ABu"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ab_11",
      "id": "ba_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brother")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Amu"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#ab_12",
      "id": "ba_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guardian")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Aql"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#ab_13",
      "id": "ba_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Security")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AKn"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#ab_14",
      "id": "ba_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sufficiency")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AIB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#ab_15",
      "id": "ba_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fulfillment")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Ats"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#ab_16",
      "id": "ba_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Everything")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz4-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part02#ab_part02",
      "id": "ba_part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2. The Bible Is Your")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz4-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#ab_17",
      "id": "ba_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Infallible Authority")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Acf"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#ab_18",
      "id": "ba_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deed of Inheritance")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AvM"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#ab_19",
      "id": "ba_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guide for Life")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AgN"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#ab_20",
      "id": "ba_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stability")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "ACg"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#ab_21",
      "id": "ba_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strength")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz5-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part03#ab_part03",
      "id": "ba_part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3. What to Do When You Feel")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz5-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#ab_22",
      "id": "ba_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discouraged")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "ApZ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#ab_23",
      "id": "ba_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Worried")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AfO"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#ab_24",
      "id": "ba_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lonely")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Add"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#ab_25",
      "id": "ba_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Depressed")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AqQ8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#ab_26",
      "id": "ba_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dissatisfied")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AGe"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#ab_27",
      "id": "ba_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Condemned")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "APqk"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#ab_28",
      "id": "ba_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confused")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AjB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#ab_29",
      "id": "ba_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempted")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "ACz"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#ab_30",
      "id": "ba_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Angry")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AxM"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#ab_31",
      "id": "ba_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rebellious")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz5-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part04#ab_part04",
      "id": "ba_part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4. What to Do When You Are")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz5-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#ab_32",
      "id": "ba_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Experiencing Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "A4U"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33#ab_33",
      "id": "ba_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Need of Fellowship")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Atn"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34#ab_34",
      "id": "ba_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Need of Courage")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AYq"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35#ab_35",
      "id": "ba_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Need of Patience")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "A38j"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36#ab_36",
      "id": "ba_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Need of Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Ah_j"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37#ab_37",
      "id": "ba_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lukewarm Spiritually")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AbQ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38#ab_38",
      "id": "ba_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Grief")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AUW"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39#ab_39",
      "id": "ba_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Doubt About God")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz5-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part05#ab_part05",
      "id": "ba_part05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5. What to Do When")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz5-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40#ab_40",
      "id": "ba_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Need Confidence")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "A3z"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41#ab_41",
      "id": "ba_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Troubles Hit Your Life")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AIe"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter42#ab_42",
      "id": "ba_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Have a Physical Sickness")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz6-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43#ab_43",
      "id": "ba_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Are in Financial Trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AP0"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter44#ab_44",
      "id": "ba_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Are Having Marital Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "A-P"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter45#ab_45",
      "id": "ba_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Are Deserted by Loved Ones")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AK_"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter46#ab_46",
      "id": "ba_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Don’t Understand God’s Ways")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AG0"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter47#ab_47",
      "id": "ba_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You are Waiting on God")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz6-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part06#ab_part06",
      "id": "ba_part06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6. What the Bible Has to Say About")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz6-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter48#ab_48",
      "id": "ba_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "A_SH"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter49#ab_49",
      "id": "ba_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AR9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter50#ab_50",
      "id": "ba_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eternity")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AO-"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter51#ab_51",
      "id": "ba_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "ABul"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter52#ab_52",
      "id": "ba_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Serving God")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Aqk1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter53#ab_53",
      "id": "ba_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Obedience")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Ahe"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter54#ab_54",
      "id": "ba_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Carnal Mind")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "ARq"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter55#ab_55",
      "id": "ba_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Grace of God")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "ANn"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter56#ab_56",
      "id": "ba_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Holy Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "A8d"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter57#ab_57",
      "id": "ba_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Faithfulness")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AlqL"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter58#ab_58",
      "id": "ba_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "A6o"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter59#ab_59",
      "id": "ba_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stewardship")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AJU"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter60#ab_60",
      "id": "ba_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Satan")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "A-Q"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter61#ab_61",
      "id": "ba_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Return of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "ABA"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter62#ab_62",
      "id": "ba_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Unsaved")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz6-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part07#ab_part07",
      "id": "ba_part07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7. Truth from the Bible About")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz6-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter63#ab_63",
      "id": "ba_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forgiving Others")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Axi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter64#ab_64",
      "id": "ba_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christian Fellowship")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz7-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter65#ab_65",
      "id": "ba_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Responsibility")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AK8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter66#ab_66",
      "id": "ba_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speaking God’s Word")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "At1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter67#ab_67",
      "id": "ba_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding the Will of God")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "ALJ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter68#ab_68",
      "id": "ba_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Answered Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AeG"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter69#ab_69",
      "id": "ba_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unsaved Loved Ones")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Ayh"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter70#ab_70",
      "id": "ba_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marriage")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AZ8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter71#ab_71",
      "id": "ba_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divorce")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Aqb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter72#ab_72",
      "id": "ba_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Family")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "ALe"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter73#ab_73",
      "id": "ba_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wives")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AMC"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter74#ab_74",
      "id": "ba_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Widows")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Ajb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter75#ab_75",
      "id": "ba_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Singles")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AgR"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter76#ab_76",
      "id": "ba_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Elderly")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz7-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part08#ab_part08",
      "id": "ba_part08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8. What You Can Do to")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "pz7-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter77#ab_77",
      "id": "ba_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grow Spiritually")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AfR"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter78#ab_78",
      "id": "ba_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Change the World")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "Aoe"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter79#ab_79",
      "id": "ba_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Help Your Business")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "AHQ"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter80#ab_80",
      "id": "ba_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Please God")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pz7-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part09#ab_part09",
      "id": "ba_part09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9. God’s Plan of Salvation")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0